import { createAsyncThunk } from "@reduxjs/toolkit";
import reportsService from "../../../api/services/reports";

export const getReports = createAsyncThunk(
  "reports/get-reports",
  async ({ filters = {}, pagination = {} } = {}) => {
    return await reportsService.getReports(filters, pagination);
  }
);

export const generateReport = createAsyncThunk(
  "reports/generate-report",
  async (reportData) => {
    return await reportsService.generateReport(reportData);
  }
);

export const downloadReport = createAsyncThunk(
  "reports/download-report",
  async (reportId) => {
    return await reportsService.downloadReport(reportId);
  }
);

export const deleteReport = createAsyncThunk(
  "reports/delete-report",
  async (reportId) => {
    return await reportsService.deleteReport(reportId);
  }
);

export const getReportStats = createAsyncThunk(
  "reports/get-stats",
  async () => {
    return await reportsService.getReportStats();
  }
);
